import React from 'react'
import { Rating } from '@softura/fluentuipackage'
import './Rating.scss'

interface IProps {
  className?: string,
  max?: number,
  defaultRating?: number
}
const RatingContainer = ({
  className,
  max,
  defaultRating
}:IProps) => {
  return (
    <Rating
      className = {`rating-star ${className}`}
      defaultRating = {defaultRating}
      max = {max}
    />
  )
}

export default RatingContainer
